const getters = {
  page_buttons: state => state.pageButton.page_buttons,
  token: state => state.user.token,
  getBnnerDetailData: state => state.bannerManage.bannerDetailData
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js